import Avatar from '../../../components/People/Member/Avatar'
import React from 'react'
import { Card, Col, Divider, Form, Icon, Modal, Row, Tabs, Tag, Tooltip } from 'antd'
import SupplierDetailsForm from '../../../components/Purchasing/Supplier/SupplierDetailsForm'
import { strVal } from '../../../modules/Utils'

const styleIcon = {
  paddingTop: '10px',
  marginRight: '5px',
  fontSize: 16,
  color: '#08c',
}

export const InfoLine = ({ tooltip, icon, label, fallout = 'N/A' }) => (
  <Row style={{ marginRight: '15px', marginLeft: '10px', fontSize: '12pt' }}>
    <Tooltip placement="right" title={tooltip}>
      <Icon type={icon} style={styleIcon} />
      {label || fallout}
    </Tooltip>
  </Row>
)

function SupplierModal(props) {
  const { visible, onCancel, confirmLoading, member, formRef } = props
  return (
    <Modal
      title="Vendor Update"
      visible={visible}
      onCancel={onCancel}
      destroyOnClose={true}
      confirmLoading={confirmLoading}
      width={'60%'}
      footer={null}>
      <div>
        <Row>
          <Card bordered={false}>
            <Col span={8} style={{ margin: 'auto' }}>
              <Avatar size={64} id={member._key} />
            </Col>

            <Col span={16} style={{ margin: 'auto', paddingTop: '15px' }}>
              <InfoLine {...{ tooltip: 'Name', icon: 'user', label: member.fn }} />
              <InfoLine {...{ tooltip: 'Position', icon: 'tool', label: member.position }} />
              <InfoLine
                {...{
                  tooltip: 'E-Mail',
                  icon: 'mail',
                  label: strVal(member, 'email.label'),
                }}
              />
            </Col>
            <Divider />
          </Card>
        </Row>
        <Row>
          <SupplierDetailsForm ref={formRef} {...props} />
        </Row>
      </div>
    </Modal>
  )
}

export default SupplierModal
